import { render, staticRenderFns } from "./AddSala.vue?vue&type=template&id=3b067140&"
import script from "./AddSala.vue?vue&type=script&lang=js&"
export * from "./AddSala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports